module.exports = __webpack_public_path__ + "admin-thumbs/s-studio-carousel.png";